export const EnumTipoEndereco = {
  Brasil: 1,
  Exterior: 2,
};
